var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "multiselect",
    _vm._b(
      {
        class: _vm.classes,
        attrs: {
          options: _vm.options,
          placeholder: _vm.placeholder,
          searchable: true,
          loading: _vm.internalIsLoading,
          "close-on-select": true,
          label: "label",
        },
        on: {
          input: _vm.updateValue,
          "search-change": _vm.handleSearch,
          close: _vm.handleClose,
        },
        model: {
          value: _vm.internalValue,
          callback: function ($$v) {
            _vm.internalValue = $$v
          },
          expression: "internalValue",
        },
      },
      "multiselect",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }